import { recoverPassword } from "api/authentication";
import { USER_NOT_FOUND } from "api/errors";
import { hasErrorCode } from "api/helper";
import { TextField } from "components/inputs";
import { Form, Formik } from "formik";
import useGoogleRecaptcha from "hooks/useGoogleRecaptcha";
import { errorToast, Heading, infoToast } from "iparque-components";
import { AppContext } from "providers/AppProvider";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import FormButton from "../FormButton";
import { getValidationSchema, initialValues } from "./configs";
import { PasswordRecoveryFormValues } from "./interfaces";

const PasswordRecoveryForm: React.FC = () => {
  const { t } = useTranslation();
  const { setIsLoading } = useContext(AppContext);
  const { executeGoogleRecaptcha, isGoogleRecaptchaLoaded } =
    useGoogleRecaptcha();

  const onSubmitHandler = async (values: PasswordRecoveryFormValues) => {
    setIsLoading(true);

    const recaptchaToken = await executeGoogleRecaptcha();
    const { success, error } = await recoverPassword(
      values.email,
      recaptchaToken
    );

    setIsLoading(false);

    if (success || hasErrorCode(USER_NOT_FOUND, error)) {
      infoToast(
        t("7885") /* Informação! */,
        t("7886") /* Verifica o teu email para criares a tua nova senha. */,
        { autoClose: false }
      );
    } else {
      errorToast(t("7847") /* Erro! */, t("3402") /* Ocorreu um erro */);
    }
  };

  return (
    <>
      <Heading className="mt-20" variant="h7">
        {t("10968") /* Ups, não se lembra da senha? */}
      </Heading>
      <Heading className="mb-20" variant="h8">
        {t("10969") /* Por favor, indique o seu endereço de email */}
      </Heading>
      <Formik
        initialValues={initialValues}
        validationSchema={getValidationSchema(t)}
        onSubmit={onSubmitHandler}
      >
        <Form>
          <TextField
            type="email"
            id="email-field"
            name="email"
            label={t("178") /* Email */}
          />
          <FormButton
            type="submit"
            disabled={!isGoogleRecaptchaLoaded}
            className="mb-10"
          >
            {t("3762") /* Recuperar */}
          </FormButton>
        </Form>
      </Formik>
    </>
  );
};

export default PasswordRecoveryForm;
